import { FC } from "react"
import { NavLink, Path } from "react-router-dom"


export type NavlinkOutlineProps = {
  toPath: string
  linkText: string
}

const NavlinkOutline: FC<NavlinkOutlineProps> = ({ toPath, linkText }) => {
  return (
    <div className="flex-none">
      <NavLink className="m-1 px-2 align-middle grow-0 border border-black" to={toPath}>{linkText}</NavLink>
    </div>
  )
}

export default NavlinkOutline